// extracted by css-extract-rspack-plugin
export default {"form":"BzyVHC","sentRoot":"o_72eK","panel":"jKCRAk","logo":"Ryhuox","field":"tcf3GY","loginRow":"OUNWgF"};